<template>
  <div v-for="trait in traits" :key="trait.id" :data-testid="`agency-trait-preview-${trait.id}`">
    <div v-if="!trait._destroy" class="flex items-start">
      <div v-if="trait.title?.[lang] || trait.description?.[lang]" class="w-12 justify-items-center">
        <UspIcon v-if="trait.kind === 'certificate'" />
        <CertIcon v-else />
      </div>
      <div class="pb-6">
        <div class="text-body-m-bold">{{ trait.title?.[lang] }}</div>
        <div>{{ trait.description?.[lang] }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { AgencyTranslatedTrait } from '@/gql/reviews/types'

import CertIcon from './CertIcon.vue'
import UspIcon from './UspIcon.vue'

defineProps<{
  traits: AgencyTranslatedTrait[]
  lang: string
}>()
</script>
